import {isArray} from "../../../../funcs";
import BaseRights from "../BaseRights";


export default class MenuReportRights extends BaseRights {
    constructor() {
        super(...arguments);
        // validate input data
        this._resetModels();
    }

    _resetModels() {
        this.reports = {};
        this.manager.roles.forEach((roleModel) => {
            let menuReports = roleModel.get("REPORTS");
            if ( !isArray(menuReports) ) {
                menuReports = [];
            }

            menuReports.forEach((menuReportApp) => {
                this.reports[ menuReportApp ] = true;
            });
        });
    }

    checkItem(menuReportApp) {
        if ( system.user.isAdmin() ) {
            return true;
        }

        return menuReportApp in this.reports;
    }

    onChange() {
        this._resetModels();
        this.trigger("change");
    }
}